var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138,
    height: 200,
    viewBox: "0 0 138 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4363 20.1549C14.2565 22.7588 17.1727 27.3634 20.5453 26.9515C23.918 26.5396 25.8915 22.1998 24.4629 19.1251C23.0343 16.0504 19.1167 14.6087 15.803 15.4179C12.2977 16.2711 9.57308 19.1692 8.08557 22.4499C6.59805 25.7305 6.15622 29.3789 5.8322 32.9537C4.35942 49.0037 4.71289 65.2156 6.89261 81.1773C7.65846 86.7382 8.67468 92.4168 11.473 97.2862C19.6175 111.497 37.7475 113.233 50.4281 104.318C57.8657 99.0957 63.0647 91.1516 66.3931 82.6926C74.1105 63.053 73.1974 40.7066 75.8337 20.2137C76.2314 17.0655 76.629 13.8143 75.7159 10.7838C74.8027 7.75328 72.1665 4.98755 69 4.95813C64.9645 4.92871 62.0337 10.2395 64.2282 13.6378C66.4226 17.0361 72.4757 16.5506 74.1105 12.8581",
    stroke: "#FBF8EF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.053 54.9609C130.783 59.9186 133.39 70.0841 130.901 77.94C125.585 94.7403 102.388 95.976 93.8902 81.0146C89.678 73.5854 92.2112 62.6697 99.9433 59.0065C107.661 55.3581 118.545 61.7576 117.941 70.2754",
    stroke: "#FBF8EF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2672 110.85C30.2215 125.164 30.7664 139.772 35.0522 153.469C39.338 167.165 47.6446 179.92 59.7067 187.702C71.7688 195.469 87.8074 197.647 100.783 191.527C114.141 185.23 122.904 173.211 119.914 157.647C117.764 146.422 108.912 136.742 97.896 133.594C88.8531 131.005 77.5568 133.623 73.2857 141.979C69.972 148.452 71.7982 156.69 76.246 162.457C83.4922 171.858 97.086 175.359 108.397 171.711C119.708 168.062 128.397 157.985 131.549 146.54C136.674 127.974 127.779 105.333 115.864 91.0928",
    stroke: "#FBF8EF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.d0c0edc7564fc4e4adfe79a404483528.svg";
export { ForwardRef as ReactComponent };